module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGGyumaoM-07657013015caf4dbaffb2b8a82acfce.png";